<template>
	<div>
		<div class="calendar">
			<!-- <a-popover   >
				<template #content>
					<router-link  v-if="list[index][formatDateTwo(index)].length > 0"  :to="{path:'/roadshow/info',query:{roadshow:list[index][formatDateTwo(index)][0].id,menuPosition:position}}">
						<div class="padding-10 font-16">{{list[index][formatDateTwo(index)][0].roadshowTitle || '暂无数据'}}</div>
					</router-link>
					<div v-else>暂无数据</div>
				</template>
				
			</a-popover> -->
			<div class="item" :class="list[index][formatDateTwo(index)].length > 0?'active':''" @click="chooseItem(index)" v-for="(item,index) in weeks" :key="index">
				<div class="week">{{item}}</div>
				<div class="date flex justify-between align-center">
					<div>{{formatDateTwo(index)}}</div>
					<!-- <div :hidden="list[index][formatDateTwo(index)]==''" class="circle"></div> -->
					<div class="circle" v-if="list[index][formatDateTwo(index)].length > 0"></div>
					<!-- <div :class="list[index][formatDateTwo(index)]!=''?'circle':''"></div> -->
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['list',"position"],
		data() {
			return {
				currentYear: 1970,
				currentMonth: 1,
				currentDay: 1,
				currentWeek: 1,
				days: [],
				weeks: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
				behindDate: '',
				frontDate: '',
				currentItemIndex: -1,
			}
		},
		created() {
			this.initData(null);
		},
		methods: {
			initList() {
				console.log(this.list);
			},
			chooseItem(index) {
				if(this.list[index][this.formatDateTwo(index)].length > 0){
					this.currentItemIndex = index;
					this.$emit("click",this.formatDate(this.days[index].getFullYear(), this.days[index].getMonth() + 1, this.days[index].getDate()));
				}
			},
			chooseDate() {
				let dateArr = [];
				this.days.forEach((item) => {
					dateArr.push(this.formatDate(item.getFullYear(), item.getMonth() + 1, item.getDate()));
				})
				return dateArr;
			},
			formatDate(year, month, day) {
				const y = year
				let m = month
				if (m < 10) m = `0${m}`
				let d = day
				if (d < 10) d = `0${d}`
				return `${y}-${m}-${d}`
			},
			formatDateTwo(index){
				const y = this.days[index].getFullYear()
				let m = this.days[index].getMonth()+1
				if (m < 10) m = `0${m}`
				let d = this.days[index].getDate()
				if (d < 10) d = `0${d}`
				return `${y}-${m}-${d}`
			},
			initData(cur) {
				let date = ''
				if (cur) {
					date = new Date(cur)
				} else {
					date = new Date()
				}
				// 今日日期 几号
				this.currentDay = date.getDate()
				// 当前年份
				this.currentYear = date.getFullYear()
				// 当前月份
				this.currentMonth = date.getMonth() + 1
				this.currentWeek = date.getDay()
				// 1...6,0  // 星期几
				if (this.currentWeek === 0) {
					this.currentWeek = 7
				}
				const str = this.formatDate(this.currentYear, this.currentMonth, this.currentDay) // 今日日期 年-月-日
				this.days.length = 0
				// 今天是周日，放在第一行第7个位置，前面6个 这里默认显示一周，如果需要显示一个月，则第二个循环为 i<= 35- this.currentWeek
				/* eslint-disabled */
				for (let i = this.currentWeek - 1; i >= 0; i -= 1) {
					const d = new Date(str)
					d.setDate(d.getDate() - i)
					this.days.push(d)
				}
				for (let i = 1; i <= 7 - this.currentWeek; i += 1) {
					const d = new Date(str)
					d.setDate(d.getDate() + i)
					this.days.push(d)
				}
				this.behindDate = this.formatDate(this.days[0].getFullYear(), this.days[0].getMonth() + 1, this.days[0]
					.getDate())
				this.frontDate = this.formatDate(this.days[6].getFullYear(), this.days[6].getMonth() + 1, this.days[6]
					.getDate())
				return {
					date: this.chooseDate()
				};
			},
			// 上个星期
			weekPre() {
				// 如果当期日期是7号或者小于7号
				const d = this.days[0]
				d.setDate(d.getDate() - 7)
				this.initData(d)
				let dateArr = this.chooseDate();
				let year = d.getFullYear();
				let month = d.getMonth() + 1;
				this.currentItemIndex = -1;
				return {
					date: dateArr,
					year: year,
					month: month
				};
			},
			// 下个星期
			weekNext() {
				// 如果当期日期是7号或者小于7号
				const d = this.days[6]
				d.setDate(d.getDate() + 7)
				this.initData(d)
				let dateArr = this.chooseDate();
				let year = d.getFullYear();
				let month = d.getMonth() + 1;
				this.currentItemIndex = -1;
				return {
					date: dateArr,
					year: year,
					month: month
				};
			},
			// 上一個月  传入当前年份和月份
			pickPre(year, month) {
				const d = new Date(this.formatDate(year, month, 1))
				d.setDate(0)
				this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1))
				this.currentItemIndex = -1;
			},
			// 下一個月  传入当前年份和月份
			pickNext(year, month) {
				const d = new Date(this.formatDate(year, month, 1))
				d.setDate(30)
				this.initData(this.formatDate(d.getFullYear(), d.getMonth() + 1, 1))
				let dateArr = this.chooseDate();
				let years = d.getFullYear();
				let months = d.getMonth() + 1;
				this.currentItemIndex = -1;
				return {
					date: dateArr,
					year: years,
					month: months
				};
			},
			// 当前选择日期
			pick(date) {
				alert(this.formatDate(date.getFullYear(), date.getMonth() + 1, date.getDate()))
			}

		}
	}
</script>

<style scoped>
	.calendar {
		display: flex;
		margin-top: 24px;
		border-bottom: 1px solid #ededed;
	}

	.circle {
		width: 8px;
		height: 8px;
		border-radius: 150px;
		background: #1C2C81;
		margin-right: 20px;
	}

	.calendar .item {
		width: 185px;
		height: 80px;
		cursor: pointer;
	}

	.calendar .item:nth-child(odd) {
		background: rgba(230, 230, 230, 0.15);
	}

	.calendar .item:nth-child(even) {
		background: rgba(230, 230, 230, 0.4);
	}

	.calendar .active {
		background-color: rgba(19, 184, 238, 0.4) !important;
	}

	.calendar .item .week {
		margin-top: 15px;
		margin-left: 20px;
	}

	.calendar .item .date {
		margin-left: 20px;
		margin-top: 12px;
	}
</style>



// WEBPACK FOOTER //
// src/components/Calendar/Calendar.vue